import React from 'react';
import './Blog.css';
import { Link } from 'react-router-dom';
import { blogPosts } from './BlogPost';

function Blog() {
    return (
        <div className="blog-container">
            <section className="blog-header-section">
                <h1>Blog</h1>
                <p>Stay informed with the latest legal news, consumer protection tips, and insights from our experienced attorneys.</p>
            </section>

            <section className="section blog-posts-section">
                <h2>Latest Articles</h2>
                <div className="blog-post-list">
                    {blogPosts.map(post => (
                        <Link to={`/blog/${post.id}`} className="blog-post-card" key={post.id}>
                            <div className="blog-post-card-category">{post.category}</div>
                            <h3 className="blog-post-card-title">{post.title}</h3>
                            <p className="blog-post-card-summary">{post.summary}</p>
                            <div className="blog-post-card-meta">
                                <span className="blog-post-card-author">{post.author}</span>
                                <span className="blog-post-card-date">{post.date}</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            <section className="section blog-coming-soon-section">
                <h2>Coming Soon</h2>
                <div className="coming-soon-content">
                    <div className="coming-soon-text">
                        <p>
                            We're currently preparing valuable content to help you understand your legal rights and stay informed about consumer protection laws. Our upcoming articles will cover:
                        </p>
                        
                        <div className="topics-grid">
                            <div className="topic-item">
                                <div className="topic-icon">⚖️</div>
                                <h3>Consumer Rights under EFTA</h3>
                                <p>Understanding your rights when dealing with businesses and financial institutions under the Electronic Fund Transfer Act (EFTA)</p>
                            </div>
                            
                            <div className="topic-item">
                                <div className="topic-icon">🏢</div>
                                <h3>Employment Law</h3>
                                <p>What your rights are regarding workplace harassment and discrimination, including unjust termination</p>
                            </div>
                            
                            <div className="topic-item">
                                <div className="topic-icon">💼</div>
                                <h3>Business Disputes</h3>
                                <p>Contract law, business litigation, and other relevant Business Disputes</p>
                            </div>
                            
                            <div className="topic-item">
                                <div className="topic-icon">🔒</div>
                                <h3>Privacy Protection</h3>
                                <p>Data breaches, privacy violations, and digital rights</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*
            <section className="section recent-cases-section">
                <h2>Recent Case Highlights</h2>
                <p>
                    While we prepare our blog content, here are some examples of the types of cases we handle and the results we achieve for our clients:
                </p>
                
                <div className="case-highlights">
                    <div className="case-highlight-item">
                        <h3>Consumer Protection Victory</h3>
                        <p>Successfully recovered thousands of dollars in unauthorized charges for EFTA violations.</p>
                    </div>
                    
                    <div className="case-highlight-item">
                        <h3>Employment Rights Defense</h3>
                        <p>Something something Andrade wrongful termination and harassment?</p>
                    </div>
                    
                    <div className="case-highlight-item">
                        <h3>Appellate Casework?</h3>
                        <p>idk what to put here (or for any of these sections really)</p>
                    </div>
                </div>
                
                <p className="case-highlight-disclaimer">
                </p>
            </section>
            */}

            <section className="section legal-assistance-section">
                <h2>Need Legal Assistance?</h2>
                <p>
                    Don't wait for our blog to launch. If you're facing legal challenges, contact us today for a consultation.
                </p>
                <div className="newsletter-actions">
                    <Link to="/client-intake" className="cta-button primary">
                        Get Legal Help Now
                    </Link>
                </div>
            </section>


        </div>
    );
}

export default Blog;